import { render, staticRenderFns } from "./mental-health-stressors-card.vue?vue&type=template&id=123780ee&scoped=true&"
import script from "./mental-health-stressors-card.vue?vue&type=script&lang=js&"
export * from "./mental-health-stressors-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123780ee",
  null
  
)

export default component.exports